import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { DealerInventoryFeedSettingsComponent } from 'app/pages/DealerInventoryFeedSettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_INVENTORY_FEED_SETTINGS } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useInventoryFeedSettingsConfigurationPage } from './hooks/useInventoryFeedSettingsConfigurationPage';

const InventoryFeedSettingsConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useInventoryFeedSettingsConfigurationPage();

  return (
    <>
      <Helmet>
        <title>Inventory Feed Settings</title>
        <meta
          name="description"
          content="Configure inventory feed store mapping for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Inventory Feed Settings"
        headerSubtitle={
          hasDealer ? (
            <DealerPageHeaderEntityInfo
              title={dealerTitle}
              dealerId={dealerId}
            />
          ) : undefined
        }
        contentVariant="centered"
      >
        <DealerInventoryFeedSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  InventoryFeedSettingsConfigurationPage,
  CONFIGURE_RESOURCE_INVENTORY_FEED_SETTINGS,
);
